import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, CreateDataForUnparse, GenerateCsv } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import translate from "@insite/client-framework/Translate";

replaceInChain(chain, CreateDataForUnparse, props => {
    const state = props.getState();
    const isAuthenticated = state.context.session.isAuthenticated;

    const { wishListLineCollection } = props.apiResult;
    if (!wishListLineCollection?.length) {
        return;
    }

    if (!isAuthenticated) {
        props.dataForUnparse = {
            fields: [
                translate("Item #"),
                translate("MFG #"),
                translate("Quantity"),
                translate("Unit of Measure"),
                translate("Brand"),
                translate("Title"),
                translate("Notes"),
            ],
            data: wishListLineCollection.map(o => [
                o.erpNumber,
                o.manufacturerItem,
                o.qtyOrdered.toString(),
                o.unitOfMeasure,
                o.brand?.name || "",
                o.shortDescription,
                o.notes,
            ]),
        };
    } else {
        props.dataForUnparse = {
            fields: [
                translate("Item #"),
                translate("MFG #"),
                translate("Quantity"),
                translate("Unit of Measure"),
                translate("Brand"),
                translate("Title"),
                translate("Price"),
                translate("Notes"),
            ],
            data: wishListLineCollection.map(o => [
                o.erpNumber,
                o.manufacturerItem,
                o.qtyOrdered.toString(),
                o.unitOfMeasure,
                o.brand?.name || "",
                o.shortDescription,
                o.quoteRequired ? "" : o.pricing?.unitRegularPrice?.toString() || "",
                o.notes,
            ]),
        };
    }
});

replaceInChain(chain, GenerateCsv, async props => {
    if (!props.dataForUnparse) {
        return;
    }
    const xlsx = await import(/* webpackChunkName: "xlsx" */ "xlsx");
    const fs = await import(/* webpackChunkName: "fs" */ "fs");
    const workbook = xlsx.utils.book_new();
    const sheetData = [props.dataForUnparse.fields, ...props.dataForUnparse.data];
    const worksheet = xlsx.utils.aoa_to_sheet(sheetData);
    xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const fileName = `wishlist_${props.parameter.wishListId}.xlsx`;
    xlsx.writeFile(workbook, fileName);
})